import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import '@/css/global.css'

const app = createApp(App)

app.config.errorHandler = () => {}

app.use(store).use(router).use(vuetify).mount('#app')

